import {
  DataEntryVehicleStepSectionProps,
  typedMemo,
  YesNoAnswer,
} from "src/types";
import { FormRow, InputDate, InputGroup, InputText } from "src/ui/widgets";
import { useDataEntryVehicleStepOwner } from "./vehicle-step-owner.hook";
import { InputPhone } from "src/ui/widgets/input-phone/input-phone";

export const DataEntryVehicleStepOwner = typedMemo(
  ({
    formikFieldBaseName,
    formikVehicleValues,
    formikVehicleErrors,
    formikVehicleTouched,
    formik,
    validationSchema,
  }: DataEntryVehicleStepSectionProps) => {
    const { vehicleOwnerTypeOptions, yesNoOptions, ownerFormVisibile, t } =
      useDataEntryVehicleStepOwner(formikVehicleValues);

    const { handleChange, handleBlur, setFieldTouched, setFieldValue } = formik;

    const requiredCodition =
      formikVehicleValues.owner.ownerCoincidesWithContractor == YesNoAnswer.NO;

    return (
      <>
        <FormRow
          firstField={
            <InputGroup
              style="radio"
              name={`${formikFieldBaseName}.owner.ownerCoincidesWithContractor`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              options={yesNoOptions}
              validationSchema={validationSchema}
              touched={
                formikVehicleTouched?.owner?.ownerCoincidesWithContractor
              }
              value={formikVehicleValues.owner.ownerCoincidesWithContractor}
              error={formikVehicleErrors?.owner?.ownerCoincidesWithContractor}
              label={t(
                "data_entry.vehicle_step.section_owner_owner_contractor_question"
              )}
              classes="m-0 ps-0"
              classesLabel="m-0 p-0 d-flex align-items-center mb-3"
            />
          }
        />

        {ownerFormVisibile && (
          <>
            <FormRow
              firstField={
                <InputGroup
                  style="radio"
                  requiredCondition={requiredCodition}
                  name={`${formikFieldBaseName}.owner.subjectType`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  options={vehicleOwnerTypeOptions}
                  validationSchema={validationSchema}
                  touched={formikVehicleTouched?.owner?.subjectType}
                  value={formikVehicleValues.owner.subjectType}
                  error={formikVehicleErrors?.owner?.subjectType}
                  label={`${t("commons.subject_type")}`}
                  classes="m-0 ps-0"
                  classesLabel="m-0 p-0 d-flex align-items-center mb-3"
                />
              }
            />
            <FormRow
              firstField={
                <InputText
                  name={`${formikFieldBaseName}.owner.name`}
                  requiredCondition={requiredCodition}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikVehicleTouched?.owner?.name}
                  value={formikVehicleValues.owner.name}
                  error={formikVehicleErrors?.owner?.name}
                  label={`${t("commons.name")}`}
                  placeholder={t("commons.insert")}
                />
              }
              secondField={
                <InputText
                  name={`${formikFieldBaseName}.owner.surname`}
                  requiredCondition={requiredCodition}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikVehicleTouched?.owner?.surname}
                  value={formikVehicleValues.owner.surname}
                  error={formikVehicleErrors?.owner?.surname}
                  label={`${t("commons.surname")}`}
                  placeholder={t("commons.insert")}
                />
              }
            />
            <FormRow
              firstField={
                <InputDate
                  name={`${formikFieldBaseName}.owner.dateOfBirth`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  validationSchema={validationSchema}
                  touched={formikVehicleTouched?.owner?.dateOfBirth}
                  value={formikVehicleValues.owner.dateOfBirth}
                  error={formikVehicleErrors?.owner?.dateOfBirth}
                  label={`${t("commons.birth_date")}`}
                  placeholder={t("commons.insert")}
                  disabledTo={undefined}
                  classes="m-0 p-0"
                />
              }
              secondField={
                <InputText
                  name={`${formikFieldBaseName}.owner.placeOfBirth`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikVehicleTouched?.owner?.placeOfBirth}
                  value={formikVehicleValues.owner.placeOfBirth}
                  error={formikVehicleErrors?.owner?.placeOfBirth}
                  label={`${t("commons.birth_palce")}`}
                  placeholder={t("commons.insert")}
                />
              }
            />
            <FormRow
              firstField={
                <InputText
                  name={`${formikFieldBaseName}.owner.fiscalCodeOrVAT`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikVehicleTouched?.owner?.fiscalCodeOrVAT}
                  value={formikVehicleValues.owner.fiscalCodeOrVAT}
                  error={formikVehicleErrors?.owner?.fiscalCodeOrVAT}
                  label={`${t("commons.fiscal_code_vat_num")}`}
                  placeholder={t("commons.insert")}
                />
              }
              secondField={
                <InputText
                  name={`${formikFieldBaseName}.owner.address`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikVehicleTouched?.owner?.address}
                  value={formikVehicleValues.owner.address}
                  error={formikVehicleErrors?.owner?.address}
                  label={`${t("commons.address_and_details")}`}
                  placeholder={t("commons.insert")}
                />
              }
            />
            <FormRow
              firstField={
                <InputPhone
                  setFieldTouched={setFieldTouched}
                  setFieldValue={setFieldValue}
                  name={`${formikFieldBaseName}.owner.phoneNumber`}
                  requiredCondition={requiredCodition}
                  touched={formikVehicleTouched?.owner?.phoneNumber}
                  value={formikVehicleValues.owner.phoneNumber}
                  error={formikVehicleErrors?.owner?.phoneNumber}
                  placeholder={t("commons.insert")}
                  label={t("commons.phone_number")}
                />
              }
              secondField={
                <InputText
                  name={`${formikFieldBaseName}.owner.email`}
                  requiredCondition={requiredCodition}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikVehicleTouched?.owner?.email}
                  value={formikVehicleValues.owner.email}
                  error={formikVehicleErrors?.owner?.email}
                  label={`${t("commons.email_address")}`}
                  placeholder={t("commons.insert")}
                />
              }
            />
          </>
        )}
      </>
    );
  }
);
